import { apiClient } from '../../../api';

// Webhook de antecipações da ApiForClient da ops atual (POST /apiForClientWebhook,
// permissão apiForClientWebhook). Um webhook por ops.

export interface ApiWebhook {
  url: string;
  ativo: boolean;
  // assina os envios (X-Planalto-Assinatura); nasce no primeiro cadastro
  segredo: string;
  atualizadoEm: string; // ISO
}

export interface ResultadoTeste {
  ok: boolean;
  status: number | null;
  duracaoMs: number;
  erro?: string;
}

const chamar = async <T>(ops: string, corpo: Record<string, unknown>): Promise<T> =>
  (await apiClient.post<T>('/apiForClientWebhook', { ops, ...corpo })).data;

export const webhookService = {
  async obter(ops: string): Promise<ApiWebhook | null> {
    return (await chamar<{ webhook: ApiWebhook | null }>(ops, { acao: 'obter' })).webhook;
  },

  async salvar(ops: string, dados: { url: string; ativo: boolean }): Promise<ApiWebhook> {
    return (await chamar<{ webhook: ApiWebhook }>(ops, { acao: 'salvar', ...dados })).webhook;
  },

  // o segredo anterior deixa de assinar os envios na hora
  async gerarSegredo(ops: string): Promise<ApiWebhook> {
    return (await chamar<{ webhook: ApiWebhook }>(ops, { acao: 'gerarSegredo' })).webhook;
  },

  async remover(ops: string): Promise<void> {
    await chamar(ops, { acao: 'remover' });
  },

  async testar(ops: string): Promise<ResultadoTeste> {
    return (await chamar<{ resultado: ResultadoTeste }>(ops, { acao: 'testar' })).resultado;
  },
};
